/**
 * Sandeep: Http service with interceptor for adding token to the header.
 * In case of any issue with token, acquireAccessToken() can be called in the interceptor direct
 * to obtain the token and call the API.
 * [09/08/2023]
 */

import axios, { AxiosError } from 'axios';
import { getOid, getToken } from './userService';
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry';
var totalCalls = 0;
/***
 * Sandeep: Instance cofiguration.
 */
const instance = axios.create({
    timeout: setting.apiTimeout,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    },
    baseURL: setting.baseAPIUrl,
    maxRedirects: 21,
});

/***
 * Sandeep: Configuring retry for http requests.
 *          Timeout requests are also retried.
 */
axiosRetry(instance, {
    retries: 0,
    retryDelay: (retryCount: number) => {
        return retryCount * 500;
    },
    shouldResetTimeout: true,
    retryCondition: (error: AxiosError) => {
        return (
            isNetworkOrIdempotentRequestError(error) || error.code === "ECONNABORTED" || error.request.status
        );
    },
    onRetry: (retryCount, error, requestConfig) => {
        return retryCount * 1000;
    },
});


/**
 * Sandeep: Create a request interceptor.
 * Inject token in the request. 
 */
instance.interceptors.request.use(function (config: any) {

    if (config.headers.Authorization == null) {
        config.headers.Authorization = 'Bearer ' + getToken();
    }
    //To check if domain is added multiple times in the header.
    if (config.headers.Domain == null || config.headers.Domain == '') {
        config.headers.Domain = setting.Domain;
    }

    //Sandeep: Add ClientId for ocelot rate limiting.
    if (config.headers.ClientId == null || config.headers.ClientId == '') {
        config.headers.ClientId = getOid();
    }
    return config;
}, function (error) {
    // handle the error
    console.log("%c" + error, 'color: red')
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response: any) {
    totalCalls--;
    // Sandeep: Do something with response data i.e. logging etc.
    return response;
}, function (error) {
    /**
     * Sandeep: Do whatever you want with the response error here:
     * But, be SURE to return the rejected promise, so the caller still has 
     * the option of additional specialized handling at the call-site.
     */

    return Promise.reject(error);
});

export default instance;
